<template>
  <div>
    <div class="order-detail-container" v-if="showDetail&&orderInfo_new">
      <div class="order-info">
        <div class="order-base-info">
          <div class="order-base-receive">
            <div>收件人信息</div>
            <ul class="info">
              <li>{{orderInfo_new.order.customerName}}</li>
              <li>{{orderInfo_new.order.customerPhone}}</li>
              <li>{{orderInfo_new.order.shippingCountry}}{{orderInfo_new.order.shippingState}}{{orderInfo_new.order.shippingCity}}{{orderInfo_new.order.shippingAddress1}}</li>
            </ul>
          </div>
          <div class="order-base-delivery">
            <div>配送方式</div>
            <div class="info">
              <div>快递</div>
              <div class="delivery-detail1">
                <!-- 物流公司-->
                {{orderInfo_new.order.shippingCourier ? orderInfo_new.order.shippingCourier: '-'}}
                <!-- 物流单号-->
                <span v-if="orderInfo_new.details[0].shippingNumber" style="padding:0 0.4rem">|</span>
                <span v-for="(it,index) in orderInfo_new.details" :key="index">
                  {{it.shippingNumber}}
                  <span
                    v-if="index<orderInfo_new.details.length-1&&it.shippingNumber"
                  >,</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="order-create-info">
          <div class="item order-time">
            <div class="item-label">下单日期</div>
            <div class="item-value">{{orderInfo_new.order.orderDate}}</div>
          </div>
          <div class="item order-no">
            <div class="item-label">订单号</div>
            <div class="item-value">{{orderInfo_new.order.portalOrderNumber}}</div>
          </div>
          <div class="item order-stauts">
            <div class="item-label">状态</div>
            <div class="orderstatus" v-if="orderInfo_new.order.orderLineStatus == 'Sent'">已完成</div>
            <div class="orderstatus" v-if="orderInfo_new.order.orderLineStatus == 'Return'">已退款</div>
            <div class="orderstatus" v-if="orderInfo_new.order.orderLineStatus == 'PartReturn'">部分退款</div>
          </div>
          <!-- <div class="item" v-if="orderInfo_new.status=='5'||refundList.length>0">
            <div class="item-label">退款信息</div>
            <div class="herf_tilte" @click="showRefoundInfo= true">查看</div>
          </div>-->
        </div>
        <div class="good-list">
          <div class="cart-item" v-for="(item, index) in orderInfo_new.details" :key="index">
            <div class="cart-left">
              <div class="cart-img">
                <img :src="item.pictureUrl" />
              </div>

              <div class="cart-info">
                <div class="cart-info-detail">
                  <div class="good-name">
                    <span>{{item.productName}}</span>
                  </div>
                  <div class="good-size">
                    尺码.
                    <span class="value">{{item.size}}</span>
                  </div>
                  <div class="good-color">
                    颜色.
                    <span class="value">{{item.colour}}</span>
                  </div>
                  <div class="good-num">
                    数量.
                    <span class="value">1</span>
                  </div>
                </div>
                <div class="cart-price">
                  <div class="all-price">
                    <span class="price">¥{{$utils.toThousands(item.valueWoShipUserCc)}}</span>
                  </div>
                  <div class="tips value" v-if="item.orderLineStatus=='Return'">已退款</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pay-info">
        <div class="pay-info-item">
          <div class="pay-info-label">商品件数：</div>
          <div class="pay-info-value">{{ orderInfo_new.details.length}}</div>
        </div>
        <div class="pay-info-item">
          <div class="pay-info-label">商品金额：</div>
          <div
            class="pay-info-value"
          >¥{{orderInfo_new.order.allValueWoShipUserCc ?$utils.toThousands(orderInfo_new.order.allValueWoShipUserCc) : $utils.toThousands(orderInfo_new.order.valueWoShipUserCc)}}</div>
        </div>
        <div class="pay-info-item">
          <div class="pay-info-label">运费：</div>
          <div
            class="pay-info-value"
          >¥{{orderInfo_new.order.allShipUserCc ? orderInfo_new.order.allShipUserCc:orderInfo_new.order.shipUserCc+'.00'}}</div>
        </div>
        <div class="pay-info-item">
          <div class="pay-info-label">实付金额：</div>
          <!--allValueWoShipUserCc 多个商品 valueWoShipUserCc只有一个商品  -->
          <div
            class="pay-info-value"
            v-if="orderInfo_new.order.allValueWoShipUserCc"
          >¥{{orderInfo_new.order.orderLineStatus == 'Sent' || orderInfo_new.order.orderLineStatus == 'PartReturn' || orderInfo_new.order.orderLineStatus == 'Return' ? $utils.toThousands(orderInfo_new.order.allValueWoShipUserCc):'¥0.00'}}</div>
          <div
            class="pay-info-value"
            v-else
          >¥{{orderInfo_new.order.orderLineStatus == 'Sent' || orderInfo_new.order.orderLineStatus == 'PartReturn' || orderInfo_new.order.orderLineStatus == 'Return' ? $utils.toThousands(orderInfo_new.order.valueWoShipUserCc):'¥0.00'}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DeliveryInfoPop from "./DeliveryInfoPop";
import RefoundInfoPop from "./RefoundInfoPop";
// import PayPop from "../common/PayPop";

export default {
  name: "PartLine",
  data() {
    return {
      showPay: false,
      showRefoundInfo: false,
      showDeliverInfo: false,
      API: this.$store.state.API,
      iscancle: false,
      status: 1,
      refundList: [],
      orderInfo_new: null,
      diffTime: 1 * 60 * 1000,
      min: "",
      sec: ""
    };
  },
  props: {
    showDetail: {
      type: Boolean,
      default: ""
    },
    orderInfo: {
      type: Object,
      default: null
    }
  },
  watch: {
    orderInfo: {
      immediate: true,
      handler(curVal, oldVal) {
        // console.log(curVal, "没有变化吗");
        this.orderInfo_new = null;
        this.orderInfo_new = curVal;
        // var create_time = this.orderInfo_new.createTime;
        // var str = create_time.replace(/\-/g, "/");
        // this.endTime = new Date(str).getTime() + 30 * 60 * 1000;
        // this.countdown();
        // this.refundList = [];
        // this.getRefundIds(this.orderInfo_new.sku);
      },
      deep: true //true 深度监听
    }
  },
  components: {
    DeliveryInfoPop,
    RefoundInfoPop
  },
  methods: {
    countdown() {
      const end = this.endTime;
      const now = new Date().getTime();
      const msec = end - now;
      let min = parseInt((msec / 1000 / 60) % 60);
      let sec = parseInt((msec / 1000) % 60);
      this.min = min > 9 ? min : "0" + min;
      this.sec = sec > 9 ? sec : "0" + sec;
      if (min >= 0 && sec >= 0) {
        if (min == 0 && sec == 0) {
          this.canCelOrder(this.orderInfo_new.id);
          return;
        }
        setTimeout(() => {
          this.countdown();
        }, 1000);
      }
    },
    getRefundIds(skus) {
      skus.forEach((v, i) => {
        if (v.refundId) {
          this.refundList.push(v.refundId);
        }
      });
    },
    goPayorderdetail() {
     
      let e = {
        id: this.orderInfo_new.id,
        totalAmount: this.orderInfo_new.totalAmount
      };
      this.$emit("goPayorderdetail", e);
    },
    cancle(id, index) {
      this.iscancle = true;
    },

    canCelOrder(id, index) {
      let url = this.API.order.cancelOrder;
      let params = {
        openId: this.$store.state.openId || this.$store.state.userId,
        orderId: id,
        formId: "12"
      };

      this.$http
        .post(url, this.$qs.stringify(params))
        .then(res => {
          if (res.data.result) {
            this.iscancle = false;
            this.showDetail = true;
            this.orderInfo_new.status = 4;
            this.$emit("refreshOrder");
            this.$Message.success("取消订单成功");
          } else {
            this.$Message.error(res.data.message);
          }
        })
        .catch(err => []);
    },
    closeInfo() {
      this.showPay = false;
      this.showRefoundInfo = false;
      this.showDeliverInfo = false;
    }
  }
};
</script>
<style lang="less" scoped>
.order-container {
  border: none;
}
.order-detail-container {
  .order-info {
    border: 0.1rem solid #eaeaea;
    .order-base-info {
      display: flex;
      padding: 2rem 2rem;
      border-bottom: 0.1rem solid #eaeaea;
      .order-base-receive {
        width: 40%;
        word-break: break-word;
        padding-right: 1rem;
      }
      .info {
        padding-top: 2rem;
        text-transform: initial;
        .delivery-detail {
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
    .order-create-info {
      padding: 2rem 2rem;
      display: flex;
      border-bottom: 0.1rem solid #eaeaea;
      margin-bottom: 2rem;
      .item {
        width: 25%;

        &.order-stauts {
          // width: 50%;
          .item-value {
            display: flex;
          }
        }
        .herf_tilte {
          cursor: pointer;
        }
        .go-pagy {
          display: flex;
          .del-tips {
            padding-left: 0.7rem;
          }
        }
      }
    }
  }

  .pay-info {
    text-align: right;
    padding: 1.5rem 0 10rem;
    width: 30%;
    float: right;
    .pay-info-item {
      display: flex;
      -webkit-box-pack: end;
      -ms-flex-pack: end;
      justify-content: space-between;
    }
  }
}

@media screen and (max-width: 768px) {
  .good-list .cart-item .cart-left .cart-img {
    flex: 2;
  }
  .order-detail-container .order-info .order-base-info .order-base-receive {
    width: 50%;
  }
  .order-detail-container .order-info .order-create-info .item {
    &.order-no {
      width: 40%;
    }
    &.order-stauts {
      width: 35%;
    }
    &.order-time {
      padding-right: 0.5rem;
    }
  }

  .order-detail-container
    .order-info
    .order-create-info
    .item.order-stauts
    .item-value {
    // flex-direction: column;
  }
  .order-detail-container .pay-info {
    padding: 1.5rem 2rem 10rem;
    width: 60%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/HistoryOrderDetail.vue